/**
 * شريط LED متعدّد الألوان يتدفّق على طول اليد (كما في فيديو باب ميلانو).
 * led = { x, y0, y1, w, bar } نِسب من أبعاد الصورة الأصلية (0-1):
 *   x   = موضع قناة الإضاءة، y0/y1 = بداية ونهاية الشريط، w = عرض اليد،
 *   bar = [x0, x1] جسم اليد المعتم الذي يبقى داكنًا فوق التوهّج.
 * crop (اختياري) = [x0, y0, x1, y1] لتحويل الإحداثيات إلى مساحة درفة الباب فقط.
 */
const LED_GRADIENT =
  "linear-gradient(180deg, #2b6bff 0%, #00d4ff 14%, #22e36b 28%, #d7f03a 42%, #ff3b30 56%, #ff2fb0 70%, #8a3cff 84%, #2b6bff 100%)";

const LedGlow = ({ led, crop, className = "" }) => {
  if (!led) return null;
  const [cx0, cy0, cx1, cy1] = crop || [0, 0, 1, 1];
  const cw = cx1 - cx0;
  const ch = cy1 - cy0;
  const px = (v) => ((v - cx0) / cw) * 100;
  const x = px(led.x);
  const top = ((led.y0 - cy0) / ch) * 100;
  const height = ((led.y1 - led.y0) / ch) * 100;
  const w = (led.w / cw) * 100;

  /* لون ثابت (مثل الأزرق) = نبض هادئ، وبدونه = تدفّق ألوان الطيف */
  const solid = !!led.color;
  const layer = (width, blur, opacity, extra = {}) => ({
    position: "absolute",
    top: `${top}%`,
    height: `${height}%`,
    left: `${x}%`,
    width: `${width}%`,
    transform: "translateX(-50%)",
    backgroundImage: solid ? `linear-gradient(180deg, ${led.color}, ${led.color})` : LED_GRADIENT,
    backgroundSize: "100% 400%",
    filter: `blur(${blur})`,
    opacity,
    borderRadius: "999px",
    animation: solid ? "none" : "ap-led-flow 7s linear infinite",
    ...extra,
  });

  return (
    <span
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={solid ? { animation: "ap-led-pulse 3.2s ease-in-out infinite" } : undefined}
      aria-hidden="true"
      data-testid="led-glow"
    >
      {/* هالة واسعة تنعكس على سطح الباب */}
      <span style={{ ...layer(w * 3.6, "12px", 0.42), mixBlendMode: "screen" }} />
      {/* توهّج قريب من قناة الإضاءة */}
      <span style={{ ...layer(w * 1.1, "4px", 0.6), mixBlendMode: "screen" }} />
      {/* جسم اليد يبقى معتمًا فوق التوهّج */}
      {led.bar && (
        <span
          style={{
            position: "absolute",
            top: `${top - 0.4}%`,
            height: `${height + 0.8}%`,
            left: `${px(led.bar[0])}%`,
            width: `${px(led.bar[1]) - px(led.bar[0])}%`,
            background: "linear-gradient(90deg, rgba(26,28,31,0.72), rgba(38,41,45,0.6) 60%, rgba(26,28,31,0.8))",
            borderRadius: "2px",
          }}
        />
      )}
      {/* قلب شريط الـ LED */}
      <span style={layer(w * 0.16, "0.3px", 0.95)} />
    </span>
  );
};

export default LedGlow;
